module.exports = ".home {\n  width: 50%;\n}\n.home .row a {\n  margin-top: 8px;\n  display: inline-block;\n  float: right;\n  text-decoration: none;\n  font-size: 0.9em;\n  -webkit-transition: all ease-in 150ms;\n  transition: all ease-in 150ms;\n}\n.home .row a:hover {\n  color: #35A2F4;\n}\n.home button.view {\n  margin-top: 20px;\n  float: right;\n  background-color: #0D4B87;\n  color: #ffffff;\n}\n.home button.view:disabled {\n  background-color: #DFDFDF;\n  color: #9F9F9F;\n  cursor: not-allowed;\n}\nmain {\n  min-height: calc(100vh - 264px);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/home/home.component.less
// module id = ./Angular/app/home/home.component.less
// module chunks = main